import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const CheckFileIngestionSchema = z.object({
	id: z.number(),
	importDate: z.date().nullable(),
	totalChecks: z.number().nullable(),
	totalAmount: z.number().nullable(),
	fileName: z.string(),
});

export type CheckFileIngestion = z.infer<typeof CheckFileIngestionSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState,
): Promise<{ data: CheckFileIngestion[]; total: number }> => {
	try {
		let queryString = '';

		const searchParams = new URLSearchParams();
		if (pagination) {
			searchParams.append('pageSize', pagination.pageSize.toString());
			searchParams.append('pageIndex', pagination.pageIndex.toString());
		}

		if (sorting.length > 0) {
			searchParams.append('sortBy', sorting[0].id);
			searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
		}

		queryString = `?${searchParams.toString()}`;

		const response = await fetch(
			`/FileIngestion/geovera-specialty-check-files${queryString}`,
		);
		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};
